import {
  OperationPlan,
  OperationPlansPerEvCar,
  OperationPlanRequest,
  DriverWorkShift,
  OperationPlanOrder,
} from "@/models/operationPlans";
import { AxiosResponse } from "axios";
import qs from "qs";
import { httpClient } from "./API";

export const getOperationPlansAPI = async (
  targetYm: string,
  page: number,
  size: number,
  order: OperationPlanOrder,
  officeIds?: number[]
): Promise<AxiosResponse<OperationPlansPerEvCar[]>> => {
  const sort = Object.entries(order)
    .filter(([, v]) => !!v)
    .map(([k, v]) => `${k},${v}`);

  return httpClient.get("/core/internal/calgary/carOperationPlans/", {
    params: {
      officeIds,
      targetYm,
      sort,
      page: page - (page < 1 ? 0 : 1),
      size,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const getOperationPlansCountAPI = async (
  targetYm: string,
  officeIds?: number[]
): Promise<AxiosResponse<number>> => {
  return httpClient.get("/core/internal/calgary/carOperationPlans/count/", {
    params: {
      officeIds,
      targetYm,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const getOperationPlanAPI = async (
  operationPlanId: number
): Promise<AxiosResponse<OperationPlan>> => {
  return httpClient.get(
    `/core/internal/calgary/carOperationPlans/${operationPlanId}`
  );
};

export const updateOperationPlanAPI = async (
  request: OperationPlanRequest
): Promise<AxiosResponse<OperationPlan>> => {
  return httpClient.post("/core/internal/calgary/carOperationPlans/", request);
};

export const getDriverWorkShiftsAPI = async (
  officeId: number
): Promise<AxiosResponse<DriverWorkShift[]>> => {
  return httpClient.get(
    "/core/internal/calgary/carOperationPlans/workShifts/",
    {
      params: { officeId },
    }
  );
};
